module.exports = __webpack_public_path__ + "img/uk-flag.5a66d32e.svg";